import React from 'react';
import { Form, Input, Button,Spin,Select,Switch,Divider } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

const { Option } = Select;

class WorkFlowForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    workflow_type:'',
    active:false,
    description:'',
    abbreviation:'',

    mineral_licence_categories:[],
    licence_types:[]

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/mineral_licence_categories/`)
    .then(res => {
        this.setState({
            mineral_licence_categories:res.data
        })
        this.setState({datarequested:false})
    })



  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('name', this.state.name);
    form_data.append('workflow_type', this.state.workflow_type);
    form_data.append('active', this.state.active);
    form_data.append('description', this.state.description);
    form_data.append('licence_types',JSON.stringify(this.state.licence_types));
   
    axios.post(serverconfig.backendserverurl+'/api/workflows/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

  }    

  )
  .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
       <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="name"
        name="name"
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input name="name"  placeholder="name." value={this.state.name} onChange={(val)=>{this.setState({name:val.target.value})}} />
      </FormItem>


      <FormItem label="Type"
        name="workflow_type"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Type" 
          style={{  }} 
          value={this.state.workflow_type}
          onChange={(val)=>{
            this.setState({workflow_type:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
                <Option value={'License'}>{'License'}</Option>
                <Option value={'Agreement'}>{'Agreement'}</Option>
                <Option value={'Group'}>{'Group'}</Option>

          </Select>
      </FormItem>


        <Form.Item label="Is Active" >
          <Switch
              checked={this.state.active}
              onChange={val=>{this.setState({active:val})}}
              checkedChildren="True"
              unCheckedChildren="False"
              />
        </Form.Item>

        <FormItem label="description">
        <TextArea
            placeholder="description"
            autoSize={{ minRows: 2, maxRows: 6 }}
            value={this.state.description}
            onChange={(val)=>{this.setState({description:val.target.value})}}
          />
        
      </FormItem>


      {
            this.state.mineral_licence_categories.length>0?
            <div style={{display:'flex',flexDirection:'column'}}>
            <h6>Applying Licences to the workflow .</h6>

            {this.state.mineral_licence_categories.map((item) => (
              <p style={{display:'flex',flexDirection:'row'}}>
              <Switch
                onChange={(val) => {
                  if (val === true) {
                   
                    var new_array = [
                      ...this.state.licence_types,
                      item.licence,
                    ];
                    this.setState({ licence_types: new_array });
                  } else {
                    this.setState({
                      licence_types: [
                        ...this.state.licence_types.filter(
                          (todo) => todo!== item.licence
                        ),
                      ],
                    });
                  }
                  
                }}
                style={{marginRight:2}} 

              ></Switch>{" "}
              {item.licence} 
            </p>

            ))}

            <Divider></Divider>
            </div>

            :
            null
          }


      <FormItem>
        <Button  type="primary" htmlType="submit">Create WorkFlow</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default WorkFlowForm;



